<template>
  <div>
    <div class="relative bg-white mb-4 px-20 py-12 rounded-lg">
      <div style="width: 58%">
        <Form
          v-slot="{ handleSubmit, resetForm, errors, meta }"
          :validation-schema="state.validationSchema"
          as="div"
        >
          <form
            @submit="handleSubmit($event, onSubmit(resetForm))"
            novalidate="novalidate"
          >
            <div style="margin-bottom: 36px">
              <div class="flex items-baseline">
                <label
                  for="oldPassword"
                  class="inline-block text-gray-92 font-semibold leading-4 mb-3"
                  >現在のパスワード</label
                >
                <span
                  class="ml-2 text-coral-main font-semibold"
                  style="font-size: 11px"
                  >必須</span
                >
              </div>
              <Field
                :validateOnInput="true"
                as="input"
                type="password"
                name="oldPassword"
                id="oldPassword"
                class="block min-w-full px-4 py-3 border rounded leading-4"
                :class="{ 'border-danger': errors.oldPassword }"
                autocomplete="off"
                v-model="state.oldPassword"
              />
              <ErrorMessage
                name="oldPassword"
                as="span"
                class="block text-danger text-xs leading-6"
              />
            </div>

            <div style="margin-bottom: 36px">
              <div class="flex items-baseline">
                <label
                  for="oldPassword"
                  class="inline-block text-gray-92 font-semibold leading-4 mb-3"
                  >新しいパスワード</label
                >
                <span
                  class="ml-2 text-coral-main font-semibold"
                  style="font-size: 11px"
                  >必須</span
                >
                <div class="ml-auto text-gray-62 text-xs">
                  半角英数8文字以上
                </div>
              </div>
              <Field
                :validateOnInput="true"
                as="input"
                type="password"
                name="newPassword"
                id="newPassword"
                class="block min-w-full px-4 py-3 border rounded leading-4"
                :class="{ 'border-danger': errors.newPassword }"
                autocomplete="off"
                v-model="state.newPassword"
              />
              <ErrorMessage
                name="newPassword"
                as="span"
                class="block text-danger text-xs leading-6"
              />
            </div>

            <div style="margin-bottom: 36px">
              <div class="flex items-baseline">
                <label
                  for="newPasswordConfirm"
                  class="inline-block text-gray-92 font-semibold leading-4 mb-3"
                  >新しいパスワード（確認）</label
                >
                <span
                  class="ml-2 text-coral-main font-semibold"
                  style="font-size: 11px"
                  >必須</span
                >
              </div>
              <Field
                :validateOnInput="true"
                as="input"
                type="password"
                name="newPasswordConfirm"
                id="newPasswordConfirm"
                class="block min-w-full px-4 py-3 border rounded leading-4"
                :class="{ 'border-danger': errors.newPasswordConfirm }"
                autocomplete="off"
                v-model="state.newPasswordConfirm"
              />
              <ErrorMessage
                name="newPasswordConfirm"
                as="span"
                class="block text-danger text-xs leading-6"
              />
            </div>

            <button
              type="submit"
              class="block mt-8 font-semibold text-white rounded focus:outline-none"
              :class="{
                'hover:button': meta.valid && meta.dirty,
                'bg-secondary-main': meta.valid && meta.dirty,
                'bg-slate-300': !meta.valid || !meta.dirty,
              }"
              :disabled="!meta.valid || !meta.dirty"
              style="width: 200px; height: 40px"
            >
              変更を保存
            </button>
          </form>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, inject } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import axios from '@/utils/axiosAuth.js';
import rules from '@/utils/validateRules.js';

export default {
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  setup() {
    const globalMethods = inject('globalMethods');

    const state = reactive({
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      validationSchema: {
        oldPassword: (value) => {
          return rules.validate(value, 'required|max:100');
        },
        newPassword: (value) => {
          const result = rules.validate(
            value,
            'required|alpha_num_special|min:8|max:100'
          );
          if (result !== true) return result;
          return value === state.oldPassword
            ? '現在のパスワードと同じです'
            : true;
        },
        newPasswordConfirm: (value) => {
          if (state.newPassword !== value) {
            return 'パスワードが一致しません';
          }
          return rules.validate(
            value,
            'required|alpha_num_special|min:8|max:100'
          );
        },
      },
    });

    const onSubmit = async (resetForm) => {
      if (
        state.oldPassword === '' ||
        state.newPassword === '' ||
        state.newPassword === '' ||
        state.newPassword !== state.newPasswordConfirm
      ) {
        return;
      }
      const postData = {
        current_password: state.oldPassword,
        new_password: state.newPassword,
        new_password_confirm: state.newPasswordConfirm,
      };
      await axios
        .post('/users/password/update', postData)
        .then((response) => {
          if (typeof response.data.data.error === 'string') {
            globalMethods.updateModal(true, response.data.data.error, ' ');
            return;
          }
          resetForm();
          globalMethods.isToast('変更が完了しました。', { timeout: 3000 });

          state.oldPassword = '';
          state.newPassword = '';
          state.newPasswordConfirm = '';
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    return {
      state,
      onSubmit,
    };
  },
};
</script>

<style lang="scss" scoped></style>
